import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Table, Loader} from 'semantic-ui-react';

class Stock extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  renderDealerStock() {
    const {stockDetail} = this.props;
    const dealers = [
      'CASABACA S. A.',
      'IMPORTADORA TOMEBAMBA S.A.',
      'TOYOCOSTA S.A',
    ];

    return dealers.map((dealer, index) => {
      return (
        <Grid.Column key={index}>
          <div className='table-scroll-container'>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan='2'>{dealer}</Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell textAlign='center' className='fixed'>Agencia</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center' className='fixed'>Cantidad</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.renderStockDetail(stockDetail[dealer])}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan='2' textAlign='center'>
                    Total: {this.getTotal(stockDetail[dealer])}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </div>
        </Grid.Column>
      );
    });
  }

  renderStockDetail(dealerStock = []) {
    return dealerStock.map((agencyStock, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>
            {agencyStock.agency} - {agencyStock.agencyName}
          </Table.Cell>
          <Table.Cell textAlign='right'>{agencyStock.stock}</Table.Cell>
        </Table.Row>
      );
    });
  }

  getTotal(dealerStock = []) {
    return dealerStock.reduce((total, agencyStock) => {
      return total + agencyStock.stock;
    }, 0);
  }

  render() {
    const {loading} = this.props;

    if (loading) {
      return (<Loader active inline='centered'>Consultando...</Loader>);
    }

    return (
      <Grid>
        <Grid.Row columns='equal'>
          {this.renderDealerStock()}
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingStockDetail,
    'stockDetail': state.partModals.stockDetail || {},
  };
};

export default connect(mapStateToProps)(Stock);
